export default __webpack_public_path__ + "static/media/ppl-border-texture.2cbd9ea6.svg";